export default __webpack_public_path__ + "static/media/message-alert.51bb32e5.wav";